import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const points = [
  { n: "01", t: "Un studio réel à Compiègne", d: "Un lieu identifié pour pratiquer, découvrir et retirer certaines commandes." },
  { n: "02", t: "1ᵉʳ centre de soin sonore dans l'Oise", d: "Un écosystème autour du yoga, des bains sonores et des instruments vibratoires." },
  { n: "03", t: "Retraites, voyages, expériences", d: "Un univers vivant qui prolonge la boutique bien au-delà de l'achat." },
  { n: "04", t: "Un accompagnement humain", d: "Conseils, orientation et contact direct pour choisir avec sérénité." },
];

export default function Partner() {
  return (
    <section
      id="partner"
      className="relative py-28 md:py-40 px-6 md:px-12 lg:px-20 bg-walnut text-cream overflow-hidden"
      data-testid="partner-section"
    >
      {/* Ambient */}
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-terracotta/20 blur-[150px]" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full bg-sage/15 blur-[120px]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-[1px] bg-terracotta" />
              <span className="text-xs uppercase tracking-[0.3em] text-cream/60">
                Partenaire officiel
              </span>
            </div>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95]">
              SoundYoga,<br />
              <span className="italic-serif text-terracotta">
                le son comme chemin.
              </span>
            </h2>
            <p className="mt-10 text-lg md:text-xl text-cream/75 font-light max-w-2xl leading-relaxed">
              Yogi Market est partenaire officiel de SoundYoga — 1<sup>er</sup>{" "}
              centre de soin sonore dans l'Oise. Un studio vivant, des bains
              sonores, des retraites et un univers où les instruments sont
              réellement joués, écoutés et transmis.
            </p>
            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="https://soundyoga.fr/"
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-terracotta text-cream text-sm uppercase tracking-[0.15em] hover:bg-cream hover:text-walnut transition-all duration-500 hover:scale-105"
                data-testid="partner-cta-discover"
              >
                Découvrir SoundYoga
                <ArrowRight
                  size={16}
                  className="group-hover:translate-x-1 transition-transform"
                />
              </a>
              <a
                href="https://compiegne.resa.soundyoga.fr/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-cream/20 text-cream text-sm uppercase tracking-[0.15em] hover:border-terracotta hover:text-terracotta transition-all duration-500"
                data-testid="partner-cta-booking"
              >
                Réserver une séance
              </a>
            </div>
          </motion.div>

          <div className="lg:col-span-5 space-y-2">
            {points.map((p, i) => (
              <motion.div
                key={p.n}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.7,
                  delay: i * 0.1,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="group flex gap-5 py-5 border-b border-cream/10 last:border-b-0 hover:bg-cream/5 transition-colors px-2 -mx-2 rounded-sm"
                data-testid={`partner-point-${i}`}
              >
                <span className="font-serif italic text-sage text-xl shrink-0">
                  {p.n}
                </span>
                <div>
                  <h4 className="font-serif text-lg md:text-xl text-cream mb-1">
                    {p.t}
                  </h4>
                  <p className="text-sm text-cream/60 leading-relaxed">
                    {p.d}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
